module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-crud-remote-select"
  }, [_c('el-select', {
    attrs: {
      "value": _vm.proxyValue,
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "Please enter a keyword",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    on: {
      "input": _vm.updateValue
    }
  }, _vm._l((_vm.results), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.parent_id === 0 && _vm.shopIsSilhouette ? item[_vm.searchKey] + ' (Group)' : item[_vm.searchKey],
        "value": item.id
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "taglist"
  }, _vm._l((_vm.valueList), function(val) {
    return _c('span', {
      staticClass: "el-tag el-tag--primary"
    }, [_vm._v("\n            " + _vm._s(val.name) + "\n            "), _c('i', {
      staticClass: "el-tag__close el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeValue(val.id)
        }
      }
    })])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-432d50d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fields/RemoteSelect.vue
// module id = 532
// module chunks = 1